import React, { useState, useEffect } from "react";
import {
  Table,
  Row,
  Col,
  Form,
  Input,
  Radio,
  Checkbox,
  Button,
  Result,
  Skeleton,
  Spin,
  Modal,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../store";
import {
  getUserRequest,
  postUserRequest,
  resetSuccessUser,
  resetUserMessage,
  updateUserRequest,
} from "../../slices/user";
import { LoadingOutlined } from "@ant-design/icons";
import { redirect } from "react-router-dom";

const UserSetting: React.FC = () => {
  const [formAdd] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [editingUser, setEditingUser] = useState<any>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isAddMode, setIsAddMode] = useState<boolean>(false);


  const dispatch = useDispatch();
  const { users, loading, isChange, isLogin, isSuccess, messageErr, isUpdate } =
    useTypedSelector((state) => {
      return {
        users: state.User.userLIst,
        loading: state.User.pageIsLoading,
        isChange: state.User.postUser,
        isLogin: state.Auth.isLogin,
        isSuccess: state.User.isSuccess,
        messageErr: state.User.message,
        isUpdate: state.User.userUpdate
      };
    });

  useEffect(() => {
    if (!isLogin) {
      redirect("/login");
    } else {
      dispatch(getUserRequest() as any);
    }
  }, [isChange, isUpdate]);

  useEffect(() => {
    dispatch(resetUserMessage());
  }, []);

  useEffect(() => {
    if (editingUser) {
      formEdit.setFieldsValue(editingUser);
    }
  }, [editingUser]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "EID",
      dataIndex: "employeeId",
      key: "employeeId",
      width: 150,
    },
    {
      title: "Role",
      dataIndex: "roles",
      key: "roles",
      width: 180,
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      render: (activity: string[]) => activity.join(", "),
      width: 300,
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
          onClick={() => handleEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEdit = (user: any) => {
    setEditingUser(user);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditingUser(null);
    setOpenModal(false);
    dispatch(resetUserMessage());
    dispatch(resetSuccessUser());
    formAdd.resetFields();
    formEdit.resetFields()
    
  };

  const showConfirmationModal = (values: any, isAdd: boolean) => {
    setModalData(values);
    setIsAddMode(isAdd);
    setOpenModal(true);
  };

  const handleModalOk = () => {
    // setOpenModal(false);
    
    if (isAddMode) {
      
      onFinish(modalData);
      
    } else {
      
      onFinishUpdate(modalData);
      
    }
  };

  console.log("MSG", messageErr);

  const onFinish = (values: any) => {
    console.log("ADD values", values);
    dispatch(postUserRequest(values) as any);
  };

  const onFinishUpdate = (values: any) => {
    console.log("EDIT values", values);
    dispatch(updateUserRequest(values) as any);
    // Tambahkan dispatch untuk update user jika tersedia
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Row gutter={16}>
        <Col span={16}>
          {!loading ? (
            <Table columns={columns} dataSource={users} />
          ) : (
            <Skeleton active />
          )}
        </Col>

        <Col span={8}>
          <div
            style={{
              backgroundColor: "#EEEEEE",
              marginBottom: 2,
              marginLeft: 10,
              borderColor: "#eaeaea",
              borderStyle: "solid",
              borderRadius: "7px",
              padding: 20,
            }}
          >
            <h4>Add User</h4>
            <Form
              form={formAdd}
              layout="vertical"
              onFinish={(values) => showConfirmationModal(values, true)}
              style={{ maxWidth: 400, margin: "0 auto" }}
            >
              <Form.Item
                label="Employee ID"
                name="employeeId"
                rules={[
                  { required: true, message: "Please input the Employee ID!" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Roles" name="roles">
                <Radio.Group>
                  <Radio value={"super-admin"}>Super Admin</Radio>
                  <Radio value={"admin"}>Admin</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item label="Activity" name="activity">
                <Checkbox.Group>
                  <Checkbox value="Read">Read</Checkbox>
                  <Checkbox value="Write">Write</Checkbox>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 20 }}
                >
                  Submit
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Form>
          </div>

          {isEditing && (
            <div
              style={{
                backgroundColor: "#E4E0E1",
                marginTop: 15,
                marginLeft: 10,
                borderColor: "#eaeaea",
                borderStyle: "solid",
                borderRadius: "7px",
                padding: 20,
              }}
            >
              <h4>Edit User</h4>
              <Form
              form={formEdit}
                layout="vertical"
                onFinish={(values) => showConfirmationModal(values, false)}
                initialValues={editingUser || {}}
                style={{ maxWidth: 400, margin: "0 auto" }}
              >
                <Form.Item
                  label="Employee ID"
                  name="employeeId"
                  rules={[
                    {
                      required: true,
                      message: "Please input the Employee ID!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item label="Roles" name="roles">
                  <Radio.Group>
                    <Radio value={"super-admin"}>Super Admin</Radio>
                    <Radio value={"admin"}>Admin</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item label="Activity" name="activity">
                  <Checkbox.Group>
                    <Checkbox value="Read">Read</Checkbox>
                    <Checkbox value="Write">Write</Checkbox>
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginRight: 20,
                      backgroundColor: "#faad14",
                      borderColor: "#faad14",
                    }}
                  >
                    Update
                  </Button>
                  <Button onClick={handleCancel}>Cancel & Close</Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Col>
      </Row>

      <Modal
        open={openModal}
        title="Confirm Action"
        onCancel={handleCancel}
        cancelText="Close"
        onOk={handleModalOk}
        okButtonProps={isSuccess || messageErr.length > 0 ? {style:{display: "none"}} : {}}
      >
        <p>
          {isAddMode 
            ? "Are you sure you want to add this user?"
            : "Are you sure you want to edit this user?"}
        </p>
        {loading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        )}
        {isSuccess && (
          <>
            <Result status="success" title="Successfully to Request" />
          </>
        )}
        {messageErr.length > 0 && (
          <>
            <Result status="warning" title={messageErr} />
          </>
        )}
      </Modal>
    </div>
  );
};

export default UserSetting;
